import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableHeadContainer,
  TableHeadItem,
  TableHeadItemRecurse,
} from '../../../../../../../components/TableHead';

export interface TransactionHeaderProps<T> {
  tableHeadItems: TableHeadItemRecurse[];
  sortColumn: keyof T | null;
  sortDirection: 'asc' | 'desc' | null;
  handleSort: (column: keyof T) => void;
}

export const TransactionHeader = <T extends Record<string, any>>({
  tableHeadItems,
  sortColumn,
  sortDirection,
  handleSort,
}: TransactionHeaderProps<T>) => (
  <TableHeadContainer px={Spacing['inline.xxxs']}>
    {tableHeadItems.map((item, index) => (
      <TableHeadItem
        key={`${item.title}-${index}`}
        {...item}
        value={item.orderValue ? String(item.orderValue) : undefined}
        orderBy={
          sortColumn
            ? {
                value: String(sortColumn),
                direction: sortDirection === 'asc' ? 'asc' : 'desc',
              }
            : undefined
        }
        onPress={() => item.orderValue && handleSort(item.orderValue as keyof T)}
      />
    ))}
  </TableHeadContainer>
);
